<template>
  <router-link tag="li" :to="to" class="nav-item">
    <ct-link type="text_secondary_light"><slot></slot></ct-link>
  </router-link>
</template>
<script>
export default {
  name: 'CtNavItem',
  props: {
    to: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

.nav-item {
  list-style: none;
  display: inline;
  margin: 0 24px;
  .ct-link {
    padding: 0;
    border: none;
    font-size:14px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    color:rgba(186,196,206,1);
    vertical-align: middle;
        word-spacing: -0.75px;
    letter-spacing: -0.15px;
  }
  &.router-link-active{
    .ct-link {
      font-family:SFProDisplay-Regular;
      font-weight:600;
      color:$secondary;
      .underline {
        background: $primary;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .nav-item {
    margin: 0 18px;
  }
}

</style>
